import React, { useContext } from 'react'
import { IntegrationsCol } from './integrations-col'
import { DomainIntegrationsManagerContext } from '../context'
import { GetDomainIntegrationResponse, GetShopifyDomainIntegrationResponse } from '@pushly/models/lib/structs/domains'
import ShopifyIntegration from '../providers/shopify-integration'
import { DomainIntegrationProviders } from '@pushly/models/lib/enums/domain-integration-providers'

const ECOMM_FEAT_FLAG = 'FEAT_DOMAIN_INTEGRATIONS_ECOMM'

const isShopifyProvider = (di: GetDomainIntegrationResponse) => di.provider === DomainIntegrationProviders.SHOPIFY

const toShopifyGetResponse = (di: GetDomainIntegrationResponse) =>
    GetShopifyDomainIntegrationResponse.fromGetDomainIntegrationResponse(di)

export const EcommIntegrations: React.FC = () => {
    const { loading, domain, integrations } = useContext(DomainIntegrationsManagerContext)

    const isEcommEnabledEnabled = domain?.flags?.includes(ECOMM_FEAT_FLAG) ?? false

    const shopifyIntegrations: GetShopifyDomainIntegrationResponse[] =
        integrations?.filter(isShopifyProvider).map(toShopifyGetResponse) ?? []

    return !isEcommEnabledEnabled ? null : (
        <IntegrationsCol className="ecomm-integrations" label="E-Commerce" loading={loading}>
            {shopifyIntegrations.length === 0 && <ShopifyIntegration loading={loading} mode="add" />}
            {shopifyIntegrations.map((di) => (
                <ShopifyIntegration key={di.id} loading={loading} mode="edit" integration={di} />
            ))}
        </IntegrationsCol>
    )
}
